//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitOptions.js";
import "../no/ScCollector.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AngleTolerance",1,0],[0,"Associative",1,0],[1,"CurveFitMethod",0,"GeometricUtilities.CurveFitOptions",0],[0,"DistanceTolerance",1,0],[1,"FaceCollector",0,"ScCollector",0],[0,"IgnoreHoles",1,0],[0,"JoinCurves",1,0]],[[[],"CollectorUpdated",{},0,0],[["solutionIndex"],"AlternateSolution",{},1,0],[[],"CurveFitMethodUpdated",{},0,0],[["nOldOutputCurves","oldOutputCurves","nNewOutputCurves","newOutputCurves"],"GetOldAndNewOutputCurves",{},0,0],[["oldOutputCurve","newOutputCurve"],"MapOutputCurve",{},2,0]],[]];
SPLM.SketchIntersectionCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchIntersectionCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;